export class EnterpriseType {
  enterpriseTypeID: number;
  name: string;
  landUseTypeID: number;

}
